import React from "react";
import { QuoteSummary } from "../../../federation/pages";
import { CircularProgress } from "@mui/material";
import axiosHandler from "../../../utils/axiosHandler.ts";
import { useNavigate } from "react-router-dom";

const RateHistory = () => {
  const navigate = useNavigate();

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <QuoteSummary axiosHandler={axiosHandler} navigate={navigate} />
    </React.Suspense>
  );
};

export default RateHistory;
